export default {
  path: "/sign-in",
  component: () => import("./index.vue"),
  name: "sign-in"
}
